import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {IAngularMyDpOptions, IMyDateModel} from 'angular-mydatepicker';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-manage-leads',
  templateUrl: './manage-leads.component.html',
  styleUrls: ['./manage-leads.component.css']
})
export class ManageLeadsComponent implements OnInit {

  myOptions: IAngularMyDpOptions = {
    dateRange: false,
    dateFormat: 'dd.mm.yyyy'
  };

  project:any;
  cost:any;
  user:any;

  leads= [] as any;
  leadDetails:any
  searchString: any = '';
  sortby: any = 'pltNo';
  plots: any;

  dateRange = [] as any;

  editFlag = false;

  leadForm: FormGroup;
  id: any;

  isloading = true;

  counter = 1;
  step1 = true;
  step2 = false;
  step3 = false;

  constructor(
    private SharedService: SharedService,
    private _formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {

    this.isloading = true;
    this.user = this.SharedService.getUser();
    this.project = this.SharedService.getProject();
    this.leads = [];

    this.SharedService.getLeads().subscribe((response)=>{
      // console.log(response)
      if(this.user.role === 'sales'){
        response.data.forEach(lead => {
          if(lead.sale_person?._id == this.user._id && this.project._id === lead.project._id){
            this.leads.push(lead)
          }
        });
      }else{
        response.data.forEach(lead => {
          if(this.project._id === lead.project._id){
            this.leads.push(lead)
          }
        });
      }

      this.isloading = false;

      console.log(this.leads)
    })

    this.leadForm = this._formBuilder.group({
      _id: [''],
      followup_date: [''],
      status: ['follow up', [Validators.required]],
    });

  }
  edit(lead): any {
    this.leadForm.patchValue(lead);
    document.getElementById("btn").click();
  }

  refresh(){
    this.ngOnInit();
  }

  info(lead: any): any {
    this.leadDetails = lead;
    console.log(lead)
    document.getElementById("info-btn").click();
  }

  onSubmit(): any {
    if (this.leadForm.invalid) {
      alert('Please fill all the required field');
      return
    } else {
      if(this.leadForm.value.followup_date.singleDate){
        // console.log(this.leadForm.value.followup_date);
        this.leadForm.patchValue({followup_date: this.leadForm.value.followup_date.singleDate.jsDate})
      }
      console.log(this.leadForm.value);
      this.SharedService.updateLead(this.leadForm.value,this.leadForm.value._id).subscribe((response) => {
        // console.log(response);
        document.getElementById("close_btn").click();
        this.ngOnInit();
      },
        (error) => {
          console.log(error);
          alert(error.error.message)
        })
    }
  }

  delete(user: any): any {

      Swal.fire({
        title: 'Are you sure?',
        text: 'Do you really want to delete lead ' + user.name,
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          if(user.status.toLowerCase() === user.property?.status.toLowerCase()){
            alert("Cannot Delete as Customer hold's a property")
          }else{
            this.SharedService.deleteLead(user._id).subscribe(response => {
              console.log(response)
              this.Toast.fire({
                title: 'Deleted!',
                text: 'The user has been deleted',
                icon: 'success'
              })
              this.ngOnInit();
            },
            (error)=>{
              console.log(error);
              this.Toast.fire({
                title: 'Error!',
                text: error.error,
                icon: 'error',
              });
            })
          }

        }
      })

  }

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

}
